import React from 'react';
import { Link } from 'react-router-dom';
import { Eye } from 'lucide-react';
import { QuickActionData } from './types';

interface QuickActionsProps {
    actions: QuickActionData[];
}

const QuickActions: React.FC<QuickActionsProps> = ({ actions }) => {
    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-gray-900">Hızlı İşlemler</h2>
                <div className="flex items-center text-sm text-gray-500">
                    <Eye className="h-4 w-4 mr-1" />
                    <span>En sık kullanılan işlemler</span>
                </div>
            </div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {actions.map((action) => {
                    const IconComponent = action.icon;
                    return (
                        <Link
                            key={action.title}
                            to={action.link}
                            className={`block p-6 border-2 rounded-xl transition-all duration-200 ${action.color} hover:shadow-lg group`}
                        >
                            <div className="flex items-start">
                                <div className={`p-3 rounded-lg mr-4 group-hover:scale-110 transition-transform duration-200`}>
                                    <IconComponent className={`h-6 w-6 ${action.iconColor}`} />
                                </div>
                                <div className="flex-1">
                                    <h3 className="text-lg font-semibold text-gray-900 group-hover:text-gray-700">
                                        {action.title}
                                    </h3>
                                    <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                                        {action.description}
                                    </p>
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default QuickActions;
